// angular
// 	.module("HeroPRO")
// 	.controller("ClosedWalkthroughController", closedWalkthroughController);

import _ from 'lodash';

import './appDetailClosed.scss';

/* @ngInject */
export default function closedWalkthroughController(FRClosingFactory, HPProjectAdvance) {
    const vm = this;
    vm.projectAdvanceData = {};
    vm.fundingRequest = [];

    vm.closedWalkthroughInstructions = '';
    vm.canDisplayContactNumber = false;

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */


    /* -----  End of Public Functions  ------*/

    /*= =======================================
	 =            Private Functions            =
	 ======================================== */


    function init() {
        FRClosingFactory.getFundingRequestClosingPromise().then(() => {
            vm.fundingRequest = FRClosingFactory.getFundingRequest();
            if (vm.fundingRequest.FundingRequestDetail.FundingDisbursementModelTypeId === 11) {
                vm.projectAdvanceData = FRClosingFactory.getProjectAdvanceDetails();

                switch (vm.projectAdvanceData.StatusName) {
                case _.keys(HPProjectAdvance)[3]:
                    vm.closedWalkthroughInstructions = 'Since an advance was paid on this project, you now have to repay it.';
                    vm.canDisplayContactNumber = true;
                    break;
                case _.keys(HPProjectAdvance)[4]:
                    vm.closedWalkthroughInstructions = 'An advance was paid on this project and the amount due back to us is past due.';
                    vm.canDisplayContactNumber = true;
                    break;
                case _.keys(HPProjectAdvance)[5]:
                    vm.closedWalkthroughInstructions = 'The advance payment on this project has been paid back.';
                    vm.canDisplayContactNumber = false;
                    break;
                default:
                    break;
                }
            }
        });
    }

    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/appDetail/walkthrough/closed/closedWalkthroughController.js